import React from "react";
import {
  AccordionPanel,
  Box,
  Divider,
  Flex,
  HStack,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import Subtopic from "./Subtopic";

interface SubtopicCollectionProps {
  tags: string[]; // may be replaced with ID in future
  //id: string;
  childContent: any[];
  // childIds: string[]
  toggleGameLiftStreamsInput: any;
}

const SubtopicCollection: React.FC<SubtopicCollectionProps> = ({ tags, childContent, toggleGameLiftStreamsInput }) => {return (
    <AccordionPanel>
      <VStack align="left">
        <UnorderedList ml="18px">
          <HStack>
            <Flex height="auto" alignSelf="stretch">
              <Divider orientation="vertical" borderWidth="1px" mr="16px"/>
              <VStack>
                {childContent.map((subtopicContent: any) => (
              // in theory you could use a field in checkboxContent for a switch statement
              // here to be able to render multiple components in this container
              // This would allow you to define multiple assessment schemas in contentful
              <Subtopic
                tags={[...tags, subtopicContent.fields.tag]}
                description={subtopicContent.fields.criteriaName}
                hasText={subtopicContent.fields.tag == 'other'}
                toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}
              />
          ))}
              </VStack>
            </Flex>
          </HStack>
        </UnorderedList>
      </VStack>
    </AccordionPanel>
  )
}

export default SubtopicCollection;
